import { render, staticRenderFns } from "./OperaBaseDataWindow.vue?vue&type=template&id=7ec7f870&"
import script from "./OperaBaseDataWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBaseDataWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports